import { useState } from 'react';
import * as xlsx from 'xlsx';
import IAdminRepository from '../../2_domain/admin/iAdminRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import LXLargeButton from '../core/components/buttons/lxLargeButton';
import { XCenter } from '../core/components/center';
import { showSuccess } from '../core/components/feedback/snackbar';
import { LXLabelInput } from '../core/texts/lxInput';
import { LXh4 } from '../core/texts/lxText';

const TestAllPage = () => {
  const adminRepo = Get.find<IAdminRepository>('IAdminRepository');

  const [accountEmail, setAccountEmail] = useState('');
  const [accountPassword, setAccountPassword] = useState('');

  const onDownloadExcel = async () => {
    await promiseResolver({
      promise: adminRepo.getAllExcelTests(),
      successCallback: (ret) => {
        const datas = ret.map((excelTest) => {
          return {
            clinicEmail: excelTest.clinic.email,
            clinicName: excelTest.clinic.name,
            patientEmail: excelTest.patient.email,
            patientName: excelTest.patient.name,
            patientDateOfBirth: excelTest.patient.birth,
            patientGender: excelTest.patient.gender,
            patientPregnancy: excelTest.patient.isPregnant,
            patientLastMensDate: excelTest.patient.menstrualDate ?? '',
            patientNik: excelTest.patient.nikOrPassport,
            patientPhone: excelTest.patient.phone,
            patientMemo: excelTest.patient.memo ?? '',
            testCodes: excelTest.test.code.join(', '),
            testCreatedAt: excelTest.test.createdAt,
            testUpdatedAt: excelTest.test.updatedAt,
          };
        });
        const ws = xlsx.utils.json_to_sheet(datas);
        const wb = xlsx.utils.book_new();

        xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
        xlsx.writeFile(wb, `${Date.now()}.xlsx`);
      },
    });
  };

  const onCreateAccount = async () => {
    await promiseResolver({
      promise: adminRepo.createClinicAccount(accountEmail, accountPassword),
      successCallback: () => {
        showSuccess('Create new account');
        setAccountEmail('');
        setAccountPassword('');
      },
    });
  };
  return (
    <XCenter>
      <Column>
        <SizedBox height={90}></SizedBox>
        <LXh4>Download Xlsx</LXh4>
        <SizedBox height={12}></SizedBox>
        <LXLargeButton width={'200px'} onClick={onDownloadExcel}>
          Download xlsx
        </LXLargeButton>

        <SizedBox height={60}></SizedBox>
        <LXLabelInput
          label="Account Email"
          onChange={setAccountEmail}
          value={accountEmail}
        ></LXLabelInput>
        <SizedBox height={24}> </SizedBox>
        <LXLabelInput
          label="Account Password"
          onChange={setAccountPassword}
          value={accountPassword}
        ></LXLabelInput>
        <SizedBox height={24}> </SizedBox>
        <LXLargeButton width={'200px'} onClick={onCreateAccount}>
          Download xlsx
        </LXLargeButton>
      </Column>
    </XCenter>
  );
};

export default TestAllPage;
